import React from "react";
import PropTypes from "prop-types";
import times from "lodash.times";
import appPath from "utils/appPath";
import { SCREENS } from "common/constants/Constants";
import Newsletter from "./newsletter/Newsletter";
import styles from "./styles.module.scss";

const NUM_LOADING_PLACEHOLDERS = 3;

class Newsletters extends React.Component {
    constructor(props) {
        super(props);

        this.props.setThinking();
    }

    componentDidMount() {
        this.props.fetchNewsletterData();
    }

    render() {
        const {
            thinking,
            newsletters = [],
            updateSubscription
        } = this.props;

        if (!thinking && !newsletters.length) {
            return null;
        }

        const actionText = "See all newsletters";

        return (
            <div>
                <NewsletterList
                    newsletters={ newsletters }
                    thinking={ thinking }
                    updateSubscription={ updateSubscription }
                />
                <a className={ styles.actionText } href={ appPath.withoutQuery(SCREENS.NEWSLETTERS) } target="_blank">
                    { actionText }
                </a>
                <div className={ styles.bottomBorder } />
            </div>
        );
    }
}

const NewsletterList = ({ newsletters, thinking, updateSubscription }) => {
    if (thinking) {
        return (
            <div className={ styles.loading }>
                <div className={ styles.loadingText }>Fetching popular newsletters </div>
                { times(NUM_LOADING_PLACEHOLDERS, (index) => <div key={ index } className={ styles.loadingPlaceholder } />) }
            </div>
        );
    }

    return (
        <div className={ styles.loaded }>
            { newsletters.map((newsletter, index) =>
                <Newsletter key={ index } onChange={ updateSubscription } { ...newsletter } />
            ) }
        </div>
    );
};

Newsletters.propTypes = {
    newsletters: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        listId: PropTypes.string.isRequired,
        mainTout: PropTypes.string,
        description: PropTypes.string,
        subscribed: PropTypes.bool.isRequired
    })),
    thinking: PropTypes.string,
    fetchNewsletterData: PropTypes.func.isRequired,
    updateSubscription: PropTypes.func.isRequired,
    setThinking: PropTypes.func.isRequired
};

export default Newsletters;
